
export const tenants = {
    t1: {
        id: 't1',
        tenantName: 'ACME Engineering',
    },
    t2: {
        id: 't2',
        tenantName: 'Legstrong Pumps',
    }
};

export const people = {
    p1: {
        id: 'p1',
        name: 'John Doe',
        photo: 63,
        company: {
            name: 'Legstrong Pumps',
        },
    },
    p2: {
        id: 'p2',
        name: 'Fran Smith',
        photo: 44,
        company: {
            name: 'ACME Engineering',
        },
    },
    p3: {
        id: 'p3',
        name: 'Clive Howie',
        photo: 52,
        company: {
            name: 'ACME Engineering',
        },
    }
};

export const projects = {
    pr1: {
        name: 'Chopper Pump Replacement',
        currentStage: {
            number: 3,
            name: 'Definition',
            deadline: '2018-08-16',
            colour: '008bc3'
        },
        bgColor: '#E75926',
    }
};

export default {
    sc1: {
        id: 'sc1',
        session: {
            info: tenants.t2,
            person: people.p1,
        },
        project: 'pr1',
    },
    sc2: {
        id: 'sc2',
        session: {
            info: tenants.t1,
            person: people.p2,
        },
        project: 'pr1',
    },
    sc3: {
        id: 'sc3',
        session: {
            info: tenants.t1,
            person: people.p3,
        },
        project: 'pr1',
    },
    fallback: {
        id: 'sc1',
        session: {
            info: tenants.t1,
            person: people.p1,
        },
        project: 'pr1',
    }
};